
export enum OrderEventType {
    CREATED,
    UPDATED,
    COMPLETED,
    CLOSED
}
